/**
 * Normaliza string pra busca client-side: minúsculas + remove acentos.
 * "Açaí" → "acai", "JOÃO" → "joao". Permite busca insensível a acento
 * (ex: digitar "acai" encontra "Açaí").
 *
 * No backend o equivalente é `unaccent()` no Postgres (busca server-side
 * de contatos). Aqui cobre os filtros client-side (lista de chats/inbox).
 */
export function normalizeSearch(s: string): string {
  return s
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .trim();
}
